import { Select } from '@mantine/core';
import { useMemo } from 'react';
import { getBrowserTimezone, timezoneToFriendlyLabel } from '@/pages/SchedulingPage/utils/common';
import { generateTimezoneOptions } from '@/pages/SchedulingPage/utils/common';

interface TimezoneInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  displaySuffix?: string;
}

export function TimezoneInput({ value, onChange, disabled, displaySuffix }: TimezoneInputProps) {
  const browserTimezone = getBrowserTimezone();
  const timezoneOptions = useMemo(() => generateTimezoneOptions(), []);

  const optionsWithDisplay = useMemo(
    () =>
      timezoneOptions.map((option) => {
        if (displaySuffix && option.value === value) {
          return {
            ...option,
            label: `${timezoneToFriendlyLabel(option.value)} - ${displaySuffix}`,
          };
        }
        return { ...option, label: timezoneToFriendlyLabel(option.value) };
      }),
    [timezoneOptions, value, displaySuffix]
  );

  return (
    <Select
      data={optionsWithDisplay}
      value={value || null}
      onChange={(val) => onChange(val || browserTimezone)}
      placeholder="Select time zone"
      disabled={disabled}
      label="Timezone"
      searchable
      required
    />
  );
}
